import { Link } from "react-router-dom";

const AnalyticalToolsContentTwo = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row reverse-mobile">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <img
                src={
                  process.env.PUBLIC_URL + "/images/resources/analytical_tools/analytical_tools_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h2>How to Use Analytical Tools</h2>
              <p>
                Accessing our Analytical Tools is simple. Choose from our range
                of data-driven solutions, from chart indicators to sentiment
                trackers, all designed to help you interpret trends and time
                your trades effectively. You can use them directly through our
                trading terminals or on any device for on-the-go analysis. With
                The Pips Analytical Tools, you don’t just view market data, you
                interpret it. Advanced charting, sentiment indicators, and
                multi-timeframe analysis help you recognize trading patterns and
                assess volatility with precision. Real-time synchronization
                ensures that your insights remain accurate and responsive,
                giving you the confidence to act decisively when market
                conditions shift.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register now
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticalToolsContentTwo;
